<!--
 * @title: 路段划分
 * @fileName: index
 * @projectName WEB
 * @author ：yaaynn
 * @date ：2020/5/22 18:17
 * @modified By：
 * @version:     1.0$
 * @description: TODO
-->
<template>
    <d2-container style="overflow: hidden;">
        <div v-show="dialogShow">
            <el-row style="margin-bottom: 20px">
                <el-col :span="4">
                  <popover-form
                    popoverWidth="680"
                    :formConfig="advSearch"
                    v-model="searchForm"
                    @onSubmit="onSearch"></popover-form>
                </el-col>
                <el-col :span="20">
                  <div class="text-align_right">
                    <el-button type="primary" @click="onAdd">新增</el-button>
                  </div>
                </el-col>
            </el-row>
            <br>
            <div>
                <dynamic-table
                        :tableSet="tableSet"
                        :tableData="tableData"
                        :pageIndex="pageIndex"
                        :pageShow="false"
                        :pageShowX="true"
                        :pageCount="pageCount"
                        @goPageIndex="goPage"
                >
                </dynamic-table>
            </div>
        </div>

        <div class="common-body" v-show="!dialogShow">
            <div class="common-flex-center-end">
                <el-button type="primary" v-if="!formDisable" @click="onSubmit">划分并保存</el-button>
                <el-button type="primary" @click="onBack">返回</el-button>

            </div>
            <div>
                <divider title="基础数据"></divider>
                <dynamic-form ref="dialogValue" :form-config="dialogFormConfig"
                              v-model="dialogValue" :disabled="formDisable"></dynamic-form>
            </div>
            <div> <divider title="养护路段"></divider></div>
            <div style="height: 400px">
                <dynamic-table
                        :tableSet="childTableSet"
                        :tableData="childTableData"
                        :pageIndex="childPageIndex"
                        :page-show="childPageSize"
                        :pageShow="false"
                        :pageShowX="true"
                        :operation-show="false"
                        :pageCount="childPageCount"
                        @goPageIndex="childGoPage"
                >
                </dynamic-table>
            </div>
            <!-- <div> <divider title="图示"></divider></div>
            <div style="width: 100%;height: 500px;  box-sizing: border-box;margin-bottom: 20px">
                <div  id="echart_001" style="width: 100%; height: 100%;"></div>
            </div> -->
        </div>
        <el-dialog :visible.sync="dialogTableVisible" width="80%" custom-class="dialogStyle">
            <route-table :tableUse="tableUses"></route-table>
        </el-dialog>
        <el-dialog :visible.sync="sectionMethodVisible" width="80%" custom-class="dialogStyle">
            <pmdSectionMaintenance :tableUse="sectionMethodTable"></pmdSectionMaintenance>
        </el-dialog>
        <el-dialog :visible.sync="partitionVisible" width="80%" custom-class="dialogStyle">
            <PavementPlanningManagement :tableUse="partitionTable"></PavementPlanningManagement>
        </el-dialog>
    </d2-container>
</template>

<script>
import PageBody from "@/components/Pages/PageBody";
import PageTable from "@/components/Pages/PageTable/index";
import RouteTable from "@/views/basic/roadProduction/routeTable";
import pmdSectionMaintenance from "@/views/decisionBase/parametersLibrary/pmdSectionMaintenance"
import PavementPlanningManagement from "@/views/decision/PavementPlanningManagement"
export default {
    name: "index",
    components: {RouteTable,pmdSectionMaintenance,PavementPlanningManagement},
    data() {
        return {
            searchForm: {
                sectionDivisionCode:"",
                routeCode:"",
            },
            advSearch: {
              list: [
                  {
                      "type": "input",
                      "icon": "icon-input",
                      "options": {
                          "width": "100%",
                          "defaultValue": "",
                          "required": false,
                          "requiredMessage": "",
                          "dataType": "string",
                          "dataTypeCheck": false,
                          "dataTypeMessage": "",
                          "pattern": "",
                          "patternCheck": false,
                          "patternMessage": "",
                          "placeholder": "",
                          "customClass": "",
                          "disabled": false,
                          "labelWidth": 100,
                          "isLabelWidth": false,
                          "hidden": false,
                          "dataBind": true,
                          "showPassword": false,
                          "remoteFunc": "func_1593590545813",
                          "remoteOption": "option_1593590545813"
                      },
                      "name": "路段划分编码",
                      "key": "1593590545813",
                      "model": "sectionDivisionCode",
                      "rules": []
                  },
                  {
                      "type": "input",
                      "icon": "icon-input",
                      "options": {
                          "width": "100%",
                          "defaultValue": "",
                          "required": false,
                          "requiredMessage": "",
                          "dataType": "string",
                          "dataTypeCheck": false,
                          "dataTypeMessage": "",
                          "pattern": "",
                          "patternCheck": false,
                          "patternMessage": "",
                          "placeholder": "",
                          "customClass": "",
                          "disabled": false,
                          "labelWidth": 100,
                          "isLabelWidth": false,
                          "hidden": false,
                          "dataBind": true,
                          "showPassword": false,
                          "remoteFunc": "func_1593590595172",
                          "remoteOption": "option_1593590595172"
                      },
                      "name": "路线编码",
                      "key": "1593590595172",
                      "model": "routeCode",
                      "rules": []
                  },
              ],
              config: {
                labelWidth: 100,
                labelPosition: "right",
                size: "medium",
                customClass: ""
              }
            },
            //分页
            paging: {},
            //搜索数据
            search:  {
                t_1: '',
                t_2: '',
                t_3: '',
                t_4: ''
            },
            //表格数据
            tableData: [],
            //页面配置
            tableSet: {
                tableColumn: [
                    {label: '路段划分编码', prop: 'sectionDivisionCode'},
                    {label: '路段划分名称', prop: 'sectionDivisionName'},
                    {label: '规划类型', prop: 'planningType',
                        type:"filter",
                        options:[{
                            "label":"项目级",
                            "value": "1"
                        },
                        {
                            "label":"路网级",
                            "value": "2"
                        }]
                    },
                    {label: '规划名称', prop: 'partitionName'},
                    {label: '规划年度', prop: 'annual'},
                    {label: '路线编码', prop: 'routeCode'},
                    {label: '路线名称', prop: 'routeName'},
                    {label: '路段划分方法', prop: 'sectionDMethod' }
                ],
                tableColBtn: [
                    {
                        show: true,
                        size: 'mini',
                        type: 'primary',
                        plain: true,
                        round: false,
                        circle: false,
                        loading: false,
                        disabled: false,
                        icon: 'el-icon-view',
                        title: '查看',
                        name: '查看',
                        click: this.onLook
                    }]
            },
            pageIndex: 1,
            pageSize: 10,
            pageCount: 0,
            pageConfig: {
                // 表格列属性
                tableColumnAttributes: [
                    {label: '路线编码', prop: 't_1', type: 'String', width: 'auto', children: []},
                    {label: '路段编码', prop: 't_2', type: 'String', width: 'auto', children: []},
                    {label: '行车方向', prop: 't_3', type: 'String', width: 'auto', children: []},
                    {label: '车道位置', prop: 't_4', type: 'String', width: 'auto', children: []},
                    {label: '起点桩号', prop: 't_5', type: 'String', width: 'auto', children: []},
                    {label: '终点桩号', prop: 't_6', type: 'String', width: 'auto', children: []},
                    {label: '养护类型', prop: 't_7', type: 'String', width: 'auto', children: []},
                    {label: '养护路段路面性能指标', width: 'auto', children: [
                            {label: 'PQI', prop: 't_8', type: 'String', width: 'auto', children: []},
                            {label: 'PCI', prop: 't_9', type: 'String', width: 'auto', children: []},
                            {label: 'RQI', prop: 't_0', type: 'String', width: 'auto', children: []},
                            {label: 'RDI', prop: 't_10', type: 'String', width: 'auto', children: []},
                            {label: 'SRI', prop: 't_11', type: 'String', width: 'auto', children: []},
                            {label: 'PSSI', prop: 't_12', type: 'String', width: 'auto', children: []},
                        ]}
                ],

            },
            childTableSet: {
                tableColumn: [
                    {label: '养护类型', prop: 'curingType'},
                    {label: '路线编码', prop: 'routeCode'},
                    {label: '路段编码', prop: 'sectionCode'},
                    {label: '行车方向', prop: 'drivingDirection'},
                    {label: '车道位置', prop: 'lane'},
                    {label: '起点桩号', prop: 'startStake',type:"stake"},
                    {label: '止点桩号', prop: 'endStake',type:"stake"},
                    {label: '路面类型', prop: 'surfaceType'},
                    {label: 'PQI', prop: 'pqi' },
                    {label: 'PCI', prop: 'pci' },
                    {label: 'RQI', prop: 'rqi' },
                    {label: 'RDI', prop: 'rdi'},
                    {label: 'SRI', prop: 'sri'},
                    {label: 'PSSI', prop: 'pssi'},
                ],
                tableColBtn: [
                    {
                        show: this.verifyAuthority('system.gsims.pmdPmAttributeScore.edit'),
                        size: 'mini',
                        type: 'primary',
                        plain: true,
                        round: false,
                        circle: false,
                        loading: false,
                        disabled: false,
                        icon: 'el-icon-edit',
                        title: '编辑',
                        name: '编辑',
                        click: this.onEdit
                    }, {
                        show: this.verifyAuthority('system.gsims.pmdPmAttributeScore.del'),
                        size: 'mini',
                        type: 'danger',
                        plain: true,
                        round: false,
                        circle: false,
                        loading: false,
                        disabled: false,
                        icon: 'el-icon-delete',
                        title: '删除',
                        name: '删除',
                        click: this.onDel
                    }]
            },
            childTableData:[],
            // 工具栏按钮
            toolbarButtons: this.ButtonEnums.BarButton.addButton,
            // 表格加载
            loading: false,
            // 查看模式
            lookModel: false,
            // 弹出层数据
            dialogValue: {
                /// 主键
                rowCode :0,
                /// 规划年度
                annual :0,
                /// 路段划分编码
                sectionDivisionCode :'',
                /// 路段划分名称
                sectionDivisionName :'',
                /// 规划类型
                planningType :'',
                /// 规划id
                partitionId :0,
                /// 规划名称（路线名称+规划年度+路面养护规划）
                partitionName :'',
                /// 路线编码
                routeCode :'',
                /// 路线id
                routeId :0,
                /// 路线名称
                routeName :'',
                /// 行政等级
                administrativeLevel :'',
                /// 路段划分方法
                sectionDMethod :'',
                /// 路段划分方法ID
                sectionDId :'',
                /// 操作员
                operator :'',
                /// 建立时间
                formativeTime :'',
                /// 制单人
                createUser :'',
                /// 制单人姓名
                createUserName :'',
                /// 制单时间
                createTime :'',
                /// 更新人
                updateUser :'',
                /// 更新人姓名
                updateUserName :'',
                /// 更新时间
                updateTime :'',
                /// 状态
                status :'',
                /// R1
                r1 :'',
                /// R2
                r2 :'',
                /// R3
                r3 :'',
                /// R4
                r4 :'',
                /// R5
                r5 :'',

                /// 路段划分详情

                sublist :'',
            },
            initForm:{
                /// 主键
                rowCode :0,
                /// 规划年度
                annual :0,
                /// 路段划分编码
                sectionDivisionCode :'',
                /// 路段划分名称
                sectionDivisionName :'',
                /// 规划类型
                planningType :'',
                /// 规划id
                partitionId :0,
                /// 规划名称（路线名称+规划年度+路面养护规划）
                partitionName :'',
                /// 路线编码
                routeCode :'',
                /// 路线id
                routeId :0,
                /// 路线名称
                routeName :'',
                /// 行政等级
                administrativeLevel :'',
                /// 路段划分方法
                sectionDMethod :'',
                /// 路段划分方法ID
                sectionDId :'',
                /// 操作员
                operator :'',
                /// 建立时间
                formativeTime :'',
                /// 制单人
                createUser :'',
                /// 制单人姓名
                createUserName :'',
                /// 制单时间
                createTime :'',
                /// 更新人
                updateUser :'',
                /// 更新人姓名
                updateUserName :'',
                /// 更新时间
                updateTime :'',
                /// 状态
                status :'',
                /// R1
                r1 :'',
                /// R2
                r2 :'',
                /// R3
                r3 :'',
                /// R4
                r4 :'',
                /// R5
                r5 :'',

                /// 路段划分详情

                sublist :'',
            },
            formDisable:false,
            testArray: [],
            //搜索框配置
            searchConfig: {"list":[{"type":"input","icon":"icon-input","options":{"width":"100%","defaultValue":"","required":false,"dataType":"string","pattern":"","placeholder":"请输入路线编码","disabled":false,"remoteFunc":"func_1590222342000_63140"},"name":"路线编码","key":"1590222342000_63140","model":"t_1","rules":[{"type":"string","message":"路线编码格式不正确"}]},{"type":"select","icon":"icon-select","options":{"defaultValue":"","multiple":false,"disabled":false,"clearable":false,"placeholder":"请选择行车方向","required":false,"showLabel":false,"width":"","options":[{"value":"上行"},{"value":"下行"}],"remote":false,"filterable":false,"remoteOptions":[],"props":{"value":"value","label":"label"},"remoteFunc":"func_1590222369000_16818"},"name":"行车方向","key":"1590223606000_84407","model":"t_2","rules":[]},{"type":"select","icon":"icon-select","options":{"defaultValue":"","multiple":false,"disabled":false,"clearable":false,"placeholder":"请选择车道位置","required":false,"showLabel":false,"width":"","options":[],"remote":false,"filterable":false,"remoteOptions":[],"props":{"value":"value","label":"label"},"remoteFunc":"func_1590222369000_16818"},"name":"车道位置","key":"1590223830000_59669","model":"t_2","rules":[]},{"type":"select","icon":"icon-select","options":{"defaultValue":"","multiple":false,"disabled":false,"clearable":false,"placeholder":"请选择路段划分方法","required":false,"showLabel":false,"width":"","options":[],"remote":false,"filterable":false,"remoteOptions":[],"props":{"value":"value","label":"label"},"remoteFunc":"func_1590222369000_16818"},"name":"路段划分方法","key":"1590223865000_18563","model":"t_2","rules":[]},{"type":"select","icon":"icon-select","options":{"defaultValue":"","multiple":false,"disabled":false,"clearable":false,"placeholder":"请选择养护类型","required":false,"showLabel":false,"width":"","options":[],"remote":false,"filterable":false,"remoteOptions":[],"props":{"value":"value","label":"label"},"remoteFunc":"func_1590222369000_16818"},"name":"养护类型","key":"1590223903000_38463","model":"t_2","rules":[]},{"type":"select","icon":"icon-select","options":{"defaultValue":"","multiple":false,"disabled":false,"clearable":false,"placeholder":"请选择层面类型","required":false,"showLabel":false,"width":"","options":[],"remote":false,"filterable":false,"remoteOptions":[],"props":{"value":"value","label":"label"},"remoteFunc":"func_1590222369000_16818"},"name":"层面类型","key":"1590222369000_16818","model":"t_2","rules":[]}],"config":{"labelWidth":100,"labelPosition":"right","size":"small"}},
            // 弹出层表单配置
            dialogFormConfig: {
                "list": [
                    {
                        "type": "input",
                        "icon": "icon-input",
                        "options": {
                            "width": "100%",
                            "defaultValue": "",
                            "required": true,
                            "requiredMessage": "",
                            "dataType": "string",
                            "dataTypeCheck": false,
                            "dataTypeMessage": "",
                            "pattern": "",
                            "patternCheck": false,
                            "patternMessage": "",
                            "placeholder": "",
                            "customClass": "",
                            "disabled": false,
                            "labelWidth": 100,
                            "isLabelWidth": false,
                            "hidden": false,
                            "dataBind": true,
                            "showPassword": false,
                            "remoteFunc": "func_1594434568022",
                            "remoteOption": "option_1594434568022",
                            "onFocus":this.showPartitionName
                        },
                        "name": "规划名称",
                        "key": "1594434568022",
                        "model": "partitionName",
                        "rules": [
                            {
                                "required": true,
                                "message": "必须填写"
                            }
                        ]
                    },
                    {
                        "type": "date",
                        "icon": "icon-date",
                        "options": {
                            "defaultValue": "",
                            "readonly": false,
                            "disabled": true,
                            "editable": true,
                            "clearable": true,
                            "placeholder": "自动生成",
                            "startPlaceholder": "",
                            "endPlaceholder": "",
                            "type": "year",
                            "format": "yyyy",
                            "timestamp": false,
                            "required": false,
                            "requiredMessage": "",
                            "width": "",
                            "customClass": "",
                            "labelWidth": 100,
                            "isLabelWidth": false,
                            "hidden": false,
                            "dataBind": true,
                            "remoteFunc": "func_1594434399576",
                            "remoteOption": "option_1594434399576"
                        },
                        "name": "规划年度",
                        "key": "1594434399576",
                        "model": "annual",
                        "rules": [

                        ]
                    },
                    {
                        "type": "input",
                        "icon": "icon-input",
                        "options": {
                            "width": "100%",
                            "defaultValue": "string",
                            "required": false,
                            "requiredMessage": "",
                            "dataType": "",
                            "dataTypeCheck": false,
                            "dataTypeMessage": "",
                            "pattern": "",
                            "patternCheck": false,
                            "patternMessage": "",
                            "placeholder": "",
                            "customClass": "",
                            "disabled": false,
                            "labelWidth": 100,
                            "isLabelWidth": false,
                            "hidden": false,
                            "dataBind": true,
                            "showPassword": false,
                            "remoteFunc": "func_1594434430596",
                            "remoteOption": "option_1594434430596"
                        },
                        "name": "路段划分编码",
                        "key": "1594434430596",
                        "model": "sectionDivisionCode",
                        "rules": []
                    },
                    {
                        "type": "input",
                        "icon": "icon-input",
                        "options": {
                            "width": "100%",
                            "defaultValue": "",
                            "required": false,
                            "requiredMessage": "",
                            "dataType": "string",
                            "dataTypeCheck": false,
                            "dataTypeMessage": "",
                            "pattern": "",
                            "patternCheck": false,
                            "patternMessage": "",
                            "placeholder": "",
                            "customClass": "",
                            "disabled": false,
                            "labelWidth": 100,
                            "isLabelWidth": false,
                            "hidden": false,
                            "dataBind": true,
                            "showPassword": false,
                            "remoteFunc": "func_1594434442317",
                            "remoteOption": "option_1594434442317"
                        },
                        "name": "路段划分名称",
                        "key": "1594434442317",
                        "model": "sectionDivisionName",
                        "rules": []
                    },
                    {
                        "type": "select",
                        "icon": "icon-select",
                        "options": {
                            "defaultValue": "",
                            "multiple": false,
                            "disabled": true,
                            "clearable": false,
                            "placeholder": "自动生成",
                            "required": false,
                            "requiredMessage": "",
                            "showLabel": false,
                            "width": "",
                            "options": [
                                {
                                    "label":"项目级",
                                    "value": "1"
                                },
                                {
                                    "label":"路网级",
                                    "value": "2"
                                }
                            ],
                            "remote": false,
                            "remoteType": "option",
                            "remoteOption": "option_1594434552359",
                            "filterable": false,
                            "remoteOptions": [],
                            "props": {
                                "value": "value",
                                "label": "label"
                            },
                            "remoteFunc": "func_1594434552359",
                            "customClass": "",
                            "labelWidth": 100,
                            "isLabelWidth": false,
                            "hidden": false,
                            "dataBind": true
                        },
                        "name": "规划类型",
                        "key": "1594434552359",
                        "model": "planningType",
                        "rules": []
                    },
                    {
                        "type": "input",
                        "icon": "icon-input",
                        "options": {
                            "width": "100%",
                            "defaultValue": "",
                            "required": false,
                            "requiredMessage": "",
                            "dataType": "string",
                            "dataTypeCheck": false,
                            "dataTypeMessage": "",
                            "pattern": "",
                            "patternCheck": false,
                            "patternMessage": "",
                            "placeholder": "自动生成",
                            "customClass": "",
                            "disabled": true,
                            "labelWidth": 100,
                            "isLabelWidth": false,
                            "hidden": false,
                            "dataBind": true,
                            "showPassword": false,
                            "remoteFunc": "func_1594434588143",
                            "remoteOption": "option_1594434588143"
                        },
                        "name": "路线编码",
                        "key": "1594434588143",
                        "model": "routeCode",
                        "rules": []
                    },
                    {
                        "type": "input",
                        "icon": "icon-input",
                        "options": {
                            "width": "100%",
                            "defaultValue": "",
                            "required": false,
                            "requiredMessage": "",
                            "dataType": "string",
                            "dataTypeCheck": false,
                            "dataTypeMessage": "",
                            "pattern": "",
                            "patternCheck": false,
                            "patternMessage": "",
                            "placeholder": "自动生成",
                            "customClass": "",
                            "disabled": true,
                            "labelWidth": 100,
                            "isLabelWidth": false,
                            "hidden": false,
                            "dataBind": true,
                            "showPassword": false,
                            "remoteFunc": "func_1594434597155",
                            "remoteOption": "option_1594434597155"
                        },
                        "name": "路线名称",
                        "key": "1594434597155",
                        "model": "routeName",
                        "rules": []
                    },
                    {
                        "type": "input",
                        "icon": "icon-input",
                        "options": {
                            "width": "100%",
                            "defaultValue": "",
                            "required": true,
                            "requiredMessage": "",
                            "dataType": "string",
                            "dataTypeCheck": false,
                            "dataTypeMessage": "",
                            "pattern": "",
                            "patternCheck": false,
                            "patternMessage": "",
                            "placeholder": "",
                            "customClass": "",
                            "disabled": false,
                            "labelWidth": 100,
                            "isLabelWidth": false,
                            "hidden": false,
                            "dataBind": true,
                            "showPassword": false,
                            "remoteFunc": "func_1594435177828",
                            "remoteOption": "option_1594435177828",
                            "onFocus":this.showSectionMethod
                        },
                        "name": "路段划分方法",
                        "key": "1594435177828",
                        "model": "sectionDMethod",
                        "rules": [{
                            "required": true,
                            "message": "必须填写"
                        }]
                    }
                ],
                "config": {
                    "labelWidth": 100,
                    "labelPosition": "right",
                    "size": "small",
                    "customClass": "",
                    "ui": "element",
                    "layout": "horizontal",
                    "labelCol": 3,
                    "width": "100%",
                    "hideLabel": false,
                    "hideErrorMessage": false
                }
            },
            // 弹出层控制属性
            dialogShow: true,
            echarts: {},
            categories: ['上行超车道', '上行行车道', '下行行车道', '下行超车道'],
            routeTypes: [
                {name: '日常养护', color: '#5B9BD5'},
                {name: '预测性养护', color: '#A5E690'},
                {name: '功能性修复', color: '#CCA4E3'},
                {name: '结构性修复', color: '#F2A0A1'},
            ],
            //路线选择
            tableUses: {
                //数据弹框
                show: true,
                size: "mini",
                type: "success",
                plain: true,
                round: false,
                circle: false,
                loading: false,
                disabled: false,
                icon: "",
                types:"0",
                title: "使用",
                name: "使用",
                click: this.useRoute
            },
            dialogTableVisible: false,
            //路段划分方法选择
            sectionMethodVisible:false,
            sectionMethodTable:{
                show: true,
                size: "mini",
                type: "success",
                plain: true,
                round: false,
                circle: false,
                loading: false,
                disabled: false,
                icon: "",
                types:1,
                title: "使用",
                name: "使用",
                click: this.useSectionMethod
            },
            //路面规划管理
            partitionVisible:false,
            partitionTable:{
                show: true,
                size: "mini",
                type: "success",
                plain: true,
                round: false,
                circle: false,
                loading: false,
                disabled: false,
                icon: "",
                types:1,
                title: "使用",
                name: "使用",
                click: this.usePartition
            },
            //子表
            childForm:{
                /// 主键
                rowCode :'',
                /// 主表id
                pCode :0,
                /// 公路等级
                highwayLevel :'',
                /// 养护类型
                curingType :'',
                /// 路段划分指标
                indexType :'',
                /// 上限值
                threshold1 :0,
                /// 下限值
                threshold2 :0,
                /// 界限值3：用于区分中修养护与大修养护的指标临界值
                threshold3 :0,
                /// 界限值4
                threshold4 :0,
                /// 界限值5
                threshold5 :0,
                /// 界限值6
                threshold6 :0,
                /// 备注
                remark :'',
                /// 制单人
                createUser :'',
                /// 制单人姓名
                createUserName :'',
                /// 制单时间
                createTime :'',
                /// 更新人
                updateUser :'',
                /// 更新人姓名
                updateUserName :'',
                /// 更新时间
                updateTime :'',
                /// 状态
                status :'',
                /// R1
                r1 :'',
                /// R2
                r2 :'',
                /// R3
                r3 :'',
                /// R4
                r4 :'',

                /// R5

                r5 :'',
            },
            childPageIndex:1,
            childPageSize:10,
            childPageCount:0
        }
    },
    methods: {
        //分页大小变更事件
        onPagingSizeChange(size) {
            this.paging.setSize(size)
            this.onSearch(this.paging, this.search)
        },
        // 分页当前页变动事件
        onPagingCurrentLimitChange(current) {
            this.paging.setIndex(current)
            this.onSearch(this.paging, this.search)
        },
        // 搜索事件
        onSearch() {

            this.$http.postHandle("", this.$url.routeDecision.getpmdsectionsdivideds, {
                ...this.searchForm,
            }).then(res => {
                this.tableData = res.data
                this.pageCount = res.pageCount
            })
        },
        //返回
        onBack(){
            this.dialogShow = true

        },
        // 新增
        onAdd() {
            this.dialogShow = false
            this.formDisable = false
            this.dialogValue = this.deepCopy(this.initForm)
            this.childTableData = []
            this.childPageCount = 0
        },
        // 查看
        onLook(row) {
            this.dialogShow = false
            this.formDisable = true
            this.dialogValue = row
            
            this.dialogValue.annual = this.dialogValue.annual.toString()
            this.getChildTable()
        },
        //划分
        onSubmit(){
            this.$refs.dialogValue.submit().then(res => {
                let dataForm = this.deepCopy(this.dialogValue)
                this.$http.postHandle("", this.$url.routeDecision.operationsectionsdivided, {
                    sectionsDivided:dataForm
                }).then(res => {
                    this.formDisable = true
                    this.dialogValue = res.data
                    this.dialogValue.annual = this.dialogValue.annual.toString()
                    this.getChildTable()
                    this.onSearch(this.paging, this.search)
                })
            })
        },
        //主表分页
        goPage(pageIndex,pageSize){
            this.pageSize = pageSize
            this.$http.postHandle("", this.$url.routeDecision.getpmdsectionsdivideds, {
                ...this.searchForm,
                pageIndex:pageIndex,
                pageSize:pageSize
            }).then(res => {
                this.tableData = res.data
                this.pageCount = res.pageCount
            })
        },
        //获取子表数据
        getChildTable(){
            let row = this.deepCopy(this.dialogValue)
            
            this.$http.post( this.$url.routeDecision.getsectionsdivideds, {
                pCode:row.rowCode,
                pageIndex:1,
                pageSize: this.childPageSize
            }).then(res => {
                this.childTableData = res.data
                this.childPageCount = res.pageCount
            })
        },
        //子表分页
        childGoPage(pageIndex,pageSize){
            let row = this.deepCopy(this.dialogValue)
            this.childPageSize = pageSize
            this.$http.post( this.$url.routeDecision.getsectionsdivideds, {
                 pCode:row.rowCode,
                pageIndex:pageIndex,
                pageSize: pageSize
            }).then(res => {
                this.childTableData = res.data
                this.childPageCount = res.pageCount
            })
        },
        initial() {
            this.onSearch(this.paging)
        },
        // 创建数据
        createData (data, routeTypes){
            let startStakeKey = 'startStake',
                endStakeKey = 'endStake',
                valueKey = 'sectionLen',
                maintainTypeKey = 'maintainTypeCode',
                pciKey = 'pciRatio',
                rdiKey = 'rdiRatio',
                rqiKey = 'rqiRatio',
                pssiKey = 'pssiRatio',
                sriKey = 'sriRatio',
                pqiKey = 'pqiRatio',
                array = []

            // for (let i = 0; i < data.length; i++) {
            //     const cache = data[i]
            //     const maintainType = Number(cache[maintainTypeKey]) - 1
            //     let routeType = 0,
            //         itemType = routeTypes[maintainType]
            //     if (cache['drivingDirectionName'].indexOf('上行') > -1 ){
            //         if (cache['lanePositionName'].indexOf('超车') > -1){
            //             routeType = this.getCategoriesIndex('上行超车道')
            //         }else{
            //             routeType = this.getCategoriesIndex('上行行车道')
            //         }
            //     }else{
            //         if (cache['lanePositionName'].indexOf('超车') > -1){
            //             routeType = this.getCategoriesIndex('下行超车道')
            //         }else{
            //             routeType = this.getCategoriesIndex('下行行车道')
            //         }
            //     }
            //     array.push({
            //         name: itemType.name,
            //         value:[
            //             routeType,
            //             cache[startStakeKey],
            //             cache[endStakeKey],
            //             cache[valueKey],
            //             maintainType,
            //             cache[pciKey],
            //             cache[rdiKey],
            //             cache[rqiKey],
            //             cache[pssiKey],
            //             cache[sriKey],
            //             cache[pqiKey]
            //         ],
            //         itemStyle: {
            //             normal: {
            //                 color: itemType.color
            //             }
            //         }
            //     })
            // }
            return array
        },
        getCategoriesIndex(name) {
            for (let i = 0; i < this.categories.length; i++) {
                if (this.categories[i] === name){
                    return i
                }
            }
        },
        setOption (option) {
            this.echarts.clear()
            this.echarts.setOption(option)
        },
        renderItem(params, api) {
            let categoryIndex = api.value(0);
            let start = api.coord([api.value(1), categoryIndex]);
            let end = api.coord([api.value(2), categoryIndex]);
            let height = api.size([0, 1])[1] * 0.6;

            let rectShape = this.$echarts.graphic.clipRectByRect({
                x: start[0],
                y: start[1] - height / 2,
                width: end[0] - start[0],
                height: height
            }, {
                x: params.coordSys.x,
                y: params.coordSys.y,
                width: params.coordSys.width,
                height: params.coordSys.height
            });

            return rectShape && {
                type: 'rect',
                shape: rectShape,
                style: api.style()
            };
        },
        createOption (data) {
            const $this = this
            const option =
                {
                    tooltip: {
                        formatter: function (params) {
                            return `${params.marker}${params.name}:${params.value[3]}米<br\>
            PCI:${params.value[4]}<br\>
            RDI:${params.value[5]}<br\>
            RQI:${params.value[6]}<br\>
            PSSI:${params.value[7]}<br\>
            SRI:${params.value[8]}<br\>
            PQI:${params.value[9]}
            `
                        },
                        textStyle:{
                            align:'left'
                        }
                    },
                    title: {
                        text: 'Profile',
                        left: 'center'
                    },
                    dataZoom: [{
                        type: 'slider',
                        filterMode: 'weakFilter',
                        showDataShadow: false,
                        bottom: 10,
                        height: 10,
                        borderColor: 'transparent',
                        backgroundColor: '#e2e2e2',
                        handleIcon: 'M10.7,11.9H9.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7v-1.2h6.6z M13.3,22H6.7v-1.2h6.6z M13.3,19.6H6.7v-1.2h6.6z', // jshint ignore:line
                        handleSize: 20,
                        handleStyle: {
                            shadowBlur: 6,
                            shadowOffsetX: 1,
                            shadowOffsetY: 2,
                            shadowColor: '#aaa'
                        },
                        labelFormatter: ''
                    }, {
                        type: 'inside',
                        filterMode: 'weakFilter'
                    }],
                    grid: {
                        height: 400,
                        bottom: 60
                    },
                    xAxis: {
                        min: 0,
                        scale: true,
                        axisLabel: {
                            formatter: function (val) {
                                let cache = Number(val / 1000).toFixed(3),
                                    caches = cache.toString().split('.')
                                let tip = `K${caches[0]}+${caches[1]}`

                                return tip;
                            }
                        }
                    },
                    yAxis: {
                        data: $this.categories
                    },
                    series: [{
                        type: 'custom',
                        renderItem: $this.renderItem,
                        itemStyle: {
                            opacity: 0.8
                        },
                        encode: {
                            x: [1, 2],
                            y: 0
                        },
                        data: data
                    }]
                }
            return option
        },
        refreshEcharts(data){
            let _data = this.createData(data, this.routeTypes)
            let option = this.createOption(_data)
            this.setOption(option)
        },
        //路线选择
        routeFileForm(){
            this.dialogTableVisible = true;
        },
        useRoute(row, index){
            this.dialogTableVisible = false
            this.dialogValue.routeCode = row.routeCode
            this.dialogValue.routeId = row.routeId
            this.dialogValue.routeName = row.routeName
        },
        //路段划分方法
        showSectionMethod(){
            this.sectionMethodVisible = true
        },
        useSectionMethod(row){
            this.dialogValue.sectionDMethod=row.partitionName
            this.dialogValue.sectionDId =row.rowCode
            this.sectionMethodVisible = false
        },
        //路面规划管理
        showPartitionName(){
            this.partitionVisible = true
        },
        usePartition(row){
            this.dialogValue.partitionName = row.planName
            this.dialogValue.partitionId = row.rowCode
            this.dialogValue.routeCode = row.routeCode
            this.dialogValue.routeId = row.routeId
            this.dialogValue.routeName = row.routeName
            this.dialogValue.planningType = row.planType
            this.dialogValue.annual = row.aannual.toString()
            this.partitionVisible = false
        }
    },
    computed: {
        // 表格按钮
        buttons() {
            return this.ButtonEnums.TableButtons.descriptionButton | this.ButtonEnums.TableButtons.deleteButton
        }
    },
    created() {
        this.onSearch()
    },
    mounted() {
        this.echarts = this.$echarts.init(document.getElementById('echart_001'), 'shine')
        // this.refreshEcharts(data.responseData.rows)
    }
}
</script>

<style scoped lang="scss">

</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/views/decision/PavementMaintenancePlanningCustomization/Segmentation/index.vue"
}
</vue-filename-injector>
